import { LIST_DESCRIPTION, LIST_FILE, LIST_NAME } from "./ListForm";
import { List } from "src/lists/objects/List";

export default interface IListData extends FormData {
  [LIST_NAME]: string;
  [LIST_DESCRIPTION]: string;
  [LIST_FILE]: FileList;
}

export function IListDataToList(formData: IListData): List {
  const list: List = new List();
  list.listName = formData[LIST_NAME].trim();
  list.description = formData[LIST_DESCRIPTION].trim();
  const file = formData[LIST_FILE].item(0);
  if (!file) {
    throw new Error("NoOp: file is not found");
  }
  list.file = file;
  return list;
}
